export * from './UiWindowNewDownRightIcon';
export * from './UiWindowNewDownRightIcon16Light';
export * from './UiWindowNewDownRightIcon16Regular';
export * from './UiWindowNewDownRightIcon16Solid';
export * from './UiWindowNewDownRightIcon20Light';
export * from './UiWindowNewDownRightIcon20Regular';
export * from './UiWindowNewDownRightIcon20Solid';
export * from './UiWindowNewDownRightIcon24Regular';
export * from './UiWindowNewDownRightIcon24Solid';
export * from './UiWindowNewDownRightIcon32Regular';
export * from './UiWindowNewDownRightIcon64Regular';
